import {
  BabaBundle,
  Bagelcode2Bundle,
  BanditosBundle,
  BingoPopBundle,
  Candivore2Bundle,
  CandivoreBundle,
  CandyCrushBundle,
  CashFrenzyBundle,
  CashmanCasinoBundle,
  ClassicBundle,
  Communix2Bundle,
  DecaBundle,
  DefaultStudioLinearBundle,
  DefaultStudioThreeInOneBundle,
  DefaultStudioTwoInOneBundle,
  DoubleHitCasinoBundle,
  DrimageBundle,
  DynamicCashManCasinoBundle,
  DynamicHeartOfVegasBundle,
  DynamicLightningLinkBundle,
  DynamicMightyFuCasinoBundle,
  EvergreenDynamicBundle,
  FabelTownBundle,
  GhostBundle,
  HeartOfVegasBundle,
  JackpotSlotsBundle,
  JunesJourneyBundle,
  LightningLinkBundle,
  LoadCompleteBundle,
  LocoBingoBundle,
  MainSubBundle,
  Me2onBundle,
  MightyFuBundle,
  PipaBundle,
  PlaydogBundle,
  PlaySimpleBundle,
  RoyalBlastBundle,
  RoyalMatchBundle,
  SpinXBundle,
  WhispersBundle
} from '@appcharge/shared-ui';

import { EBundlesInternalViewModel } from '../constants/enums';

export const mapBundleComponents: Record<EBundlesInternalViewModel, any> = {
  [EBundlesInternalViewModel.AK]: ClassicBundle,
  [EBundlesInternalViewModel.GENNMU]: Bagelcode2Bundle,
  [EBundlesInternalViewModel.ME2ON]: Me2onBundle,
  [EBundlesInternalViewModel.MAIN_SUB]: MainSubBundle,
  [EBundlesInternalViewModel.COMMUNIX2]: Communix2Bundle,
  [EBundlesInternalViewModel.MATCH]: CandivoreBundle,
  [EBundlesInternalViewModel.BAGELCODE2]: Bagelcode2Bundle,
  [EBundlesInternalViewModel.LOCO_BINGO]: LocoBingoBundle,
  [EBundlesInternalViewModel.JACKPOT_SLOTS]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.BIG_FISH_CASINO]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkBundle,
  [EBundlesInternalViewModel.EVERGREEN_DYNAMIC]: EvergreenDynamicBundle,
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasBundle,
  [EBundlesInternalViewModel.PLAY_SIMPLE]: PlaySimpleBundle,
  [EBundlesInternalViewModel.PIPA]: PipaBundle,
  [EBundlesInternalViewModel.BABA]: BabaBundle,
  [EBundlesInternalViewModel.WHISPERS]: WhispersBundle,
  [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: MightyFuBundle,
  [EBundlesInternalViewModel.CANDIVORE]: Candivore2Bundle,
  [EBundlesInternalViewModel.GHOST]: GhostBundle,
  [EBundlesInternalViewModel.GHOST_DOUBLE_HIT_CASINO]: DoubleHitCasinoBundle,
  [EBundlesInternalViewModel.BINGO_POP]: BingoPopBundle,
  [EBundlesInternalViewModel.ROYAL_MATCH]: RoyalMatchBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2]:
    DynamicLightningLinkBundle,
  [EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS]: DynamicHeartOfVegasBundle,
  [EBundlesInternalViewModel.FABEL_TOWN]: FabelTownBundle,
  [EBundlesInternalViewModel.DYNAMIC_MIGHTY_FU_CASINO]:
    DynamicMightyFuCasinoBundle,
  [EBundlesInternalViewModel.DECA]: DecaBundle,
  [EBundlesInternalViewModel.LOAD_COMPLETE]: LoadCompleteBundle,
  [EBundlesInternalViewModel.DYNAMIC_CASH_MAN_CASINO]:
    DynamicCashManCasinoBundle,
  [EBundlesInternalViewModel.PLAYDOG]: PlaydogBundle,
  [EBundlesInternalViewModel.SPIN_X]: SpinXBundle,
  [EBundlesInternalViewModel.CASH_FRENZY]: CashFrenzyBundle,
  [EBundlesInternalViewModel.JUNES_JOURNEY]: JunesJourneyBundle,
  [EBundlesInternalViewModel.BANDITOS]: BanditosBundle,
  [EBundlesInternalViewModel.ROYAL_BLAST]: RoyalBlastBundle,
  [EBundlesInternalViewModel.STUDIO_DEFAULT_LINEAR]: DefaultStudioLinearBundle,
  [EBundlesInternalViewModel.STUDIO_DEFAULT_TWO_IN_ONE]:
    DefaultStudioTwoInOneBundle,
  [EBundlesInternalViewModel.STUDIO_DEFAULT_THREE_IN_ONE]:
    DefaultStudioThreeInOneBundle,
  [EBundlesInternalViewModel.DRIMAGE]: DrimageBundle,
  [EBundlesInternalViewModel.CANDY_CRUSH]: CandyCrushBundle,
  [EBundlesInternalViewModel.COOKING_MADNESS]: DefaultStudioLinearBundle
};
